module.exports = __webpack_public_path__ + "public-ui/img/sber.ecbb0e6b.svg";